/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FaqPaginateResponse } from '../../models/faq-paginate-response';

export interface GetFaqIndex$Params {

/**
 * Pagination offset
 */
  page?: number;

/**
 * Pagination limit
 */
  limit?: number;

/**
 * Pagination order field ascending
 */
  orderAsc?: 'id' | 'label' | 'name' | 'priority';

/**
 * Pagination order field descending
 */
  orderDesc?: 'id' | 'label' | 'name' | 'priority';

/**
 * Filter faq id
 */
  id?: number;

/**
 * Filter category by name
 */
  category?: string;

/**
 * Filter by content text
 */
  content?: string;

/**
 * Filter by label text
 */
  label?: string;

/**
 * Filter by name
 */
  name?: string;

/**
 * Filter by related questions name
 */
  related?: string;

/**
 * Full text search
 */
  query?: string;
}

export function getFaqIndex(http: HttpClient, rootUrl: string, params?: GetFaqIndex$Params, context?: HttpContext): Observable<StrictHttpResponse<FaqPaginateResponse>> {
  const rb = new RequestBuilder(rootUrl, getFaqIndex.PATH, 'get');
  if (params) {
    rb.query('page', params.page, {});
    rb.query('limit', params.limit, {});
    rb.query('orderAsc', params.orderAsc, {});
    rb.query('orderDesc', params.orderDesc, {});
    rb.query('id', params.id, {});
    rb.query('category', params.category, {});
    rb.query('content', params.content, {});
    rb.query('label', params.label, {});
    rb.query('name', params.name, {});
    rb.query('related', params.related, {});
    rb.query('query', params.query, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FaqPaginateResponse>;
    })
  );
}

getFaqIndex.PATH = '/v1/faq';
